// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/fonts/IRANSansX-DemiBold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

@font-face {
    font-family: IranSans;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

html, body {
    direction: rtl;
    background-color: rgba(249, 250, 253, 1) !important;
    font-family: IranSans !important;
    height: 100%;
    margin: 0;
    padding: 0;
      overflow-x: hidden !important;
}



@media (max-width:990px) {
    html, body {
        overflow-y: scroll !important;
  overflow-x: hidden !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,4CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,mDAAmD;IACnD,gCAAgC;IAChC,YAAY;IACZ,SAAS;IACT,UAAU;MACR,6BAA6B;AACnC;;;;AAIA;IACI;QACI,6BAA6B;EACnC,6BAA6B;IAC3B;AACJ","sourcesContent":["* {\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n}\n\n@font-face {\n    font-family: IranSans;\n    src: url(\"/src/fonts/IRANSansX-DemiBold.woff\");\n}\n\nhtml, body {\n    direction: rtl;\n    background-color: rgba(249, 250, 253, 1) !important;\n    font-family: IranSans !important;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n      overflow-x: hidden !important;\n}\n\n\n\n@media (max-width:990px) {\n    html, body {\n        overflow-y: scroll !important;\n  overflow-x: hidden !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
